import { SingleCombo } from "./single_combo.js";
import { ComboCinema } from "./combo_cinema.js";
import { SingleComboModal } from "./modal/single_combo_modal.js";

export class Initialization {
	initialize(content, type) {
		if (type === "cinema") {
			this._initializeComboCinema(content);
		} else {
			this._initializeCombo(content);
		}
	}

	_initializeCombo(comboContents) {
		let combo;
		Array.prototype.forEach.call(comboContents, comboElement => {
			if (!this._isInitialized(comboElement)) {
				combo = new SingleCombo(comboElement);

				this._setIsInitialized(comboElement);
				combo.addClickHandlers();
				combo.addWishlistButtonClickHandler();
				combo.sendViewTracking();
			}
		});
	}

	_initializeComboCinema(comboContents) {
		let comboCinema;
		Array.prototype.forEach.call(comboContents, comboElement => {
			if (!this._isInitialized(comboElement)) {
				comboCinema = new ComboCinema(comboElement);

				this._setIsInitialized(comboElement);
				comboCinema.addClickHandlers();
				comboCinema.initCinemaEvents();
				comboCinema.addWishlistButtonClickHandler();
			}
		});
	}

	_isInitialized(comboElement) {
		return comboElement.dataset.tracked === "true";
	}

	_setIsInitialized(comboElement) {
		comboElement.dataset.tracked = "true";
	}

	initializeModal(content) {
		let comboModal;

		if (!this._isInitialized(content)) {
			comboModal = new SingleComboModal(content);

			this._setIsInitialized(content);
			comboModal.sendViewTracking();
		}
	}
}
